<!--
 * @Author: Shen Kui
 * @LastEditTime: 2022-10-08 15:31:29
 * @Description:
-->
<template>
  <el-card class="h-full" :body-style="{ height: '100%', padding: '10px' }">
    <el-tabs class="h-full" v-model="tabActive" @tab-click="handleClick">
      <el-tab-pane class="h-full" :label="`${$t('underlyingRuleManagement')}`" name="base">
        <div class="h-full w-full">
          <el-row>
            <selectStandardId @updateStandardId="updateStandardId" />
            <el-input
              v-model.trim="searchBaseRuleKey"
              :placeholder="`${$t('searchForTheBaseRuleName')}`"
              clearable
              size="small"
              class="mr-10px w-200px ml-10px"
            ></el-input>
            <el-button type="primary" @click="initBaseRuleList">{{ $t('search') }}</el-button>
            <el-button
              :disabled="!$hasAccess('create')"
              type="primary"
              @click="openBaseRuleEditDialog(null)"
              >{{ $t('new') }}</el-button
            >
            <el-button
              :disabled="!$hasAccess('delete')"
              type="danger"
              @click="deleteBaseRule(baseRuleSelectionIds)"
              >{{ $t('delete') }}</el-button
            >
            <el-button :disabled="!$hasAccess('export')" @click="exportBaseRule">{{
              $t('export')
            }}</el-button>
            <el-button :disabled="!$hasAccess('import')" @click="importBaseFile">{{
              $t('import')
            }}</el-button>
          </el-row>
          <div class="mt-20px table-content">
            <el-table
              :data="baseRuleList"
              height="100%"
              border
              stripe
              v-loading="baseRuleListLoading"
              ref="baseRuleTable"
              row-key="id"
              @selection-change="selectionBaseRule"
            >
              <el-table-column
                :reserve-selection="true"
                type="selection"
                width="40px"
              ></el-table-column>
              <el-table-column
                prop="seqNo"
                :label="`${$t('serialNumber')}`"
                width="75px"
              ></el-table-column>
              <el-table-column
                prop="name"
                :label="`${$t('TheNameOfTheUnderlyingRule')}`"
              ></el-table-column>
              <el-table-column
                prop="definition"
                :label="`${$t('underlyingRuleDefinitions')}`"
              ></el-table-column>
              <el-table-column
                prop="significantDigits"
                :label="`${$t('numberOfDigits')}`"
              ></el-table-column>
              <el-table-column :label="`${$t('operate')}`" align="center" width="180px">
                <template #default="{ row }">
                  <el-button
                    :disabled="!$hasAccess('update')"
                    size="mini"
                    @click="openBaseRuleEditDialog(row)"
                    >{{ $t('edit') }}</el-button
                  >
                  <el-button
                    :disabled="!$hasAccess('delete')"
                    size="mini"
                    @click="deleteBaseRule([row.id])"
                    >{{ $t('delete') }}</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              background
              @size-change="changeBaseRuleSize"
              @current-change="changeBaseRulePage"
              :current-page.sync="baseRulePagination.pageNo"
              :page-size.sync="baseRulePagination.pageSize"
              :page-sizes="$pageSizeAll"
              layout="total, sizes, prev, pager, next, jumper"
              :total="baseRulePagination.totalCount"
              class="mt-20px float-right"
            ></el-pagination>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane class="h-full" :label="`${$t('encodingRuleManagement')}`" name="encode">
        <el-row class="h-full" :gutter="10">
          <el-col class="h-full" :span="14">
            <el-card
              class="h-full w-full"
              :body-style="{ height: 'calc(100% - 44px)', padding: '10px' }"
            >
              <div slot="header">
                <el-row :gutter="10" class="fz-16" type="flex" align="middle">
                  <el-col :span="18">
                    <span>{{ `${$t('codeRules')}` }}</span>
                  </el-col>
                  <el-col :span="6">
                    <div class="float-right">
                      <el-switch
                        v-model="isAllRegister"
                        @change="changeAllRegister"
                        active-color="#13ce66"
                        inactive-color="#e7e9ee"
                      ></el-switch>
                      <span
                        :class="{ 'text-color-blue': isAllRegister }"
                        class="fz-14 mr-10px ml-10px"
                        >{{ `${$t('registerAll')}` }}</span
                      >
                      <el-popover
                        ref="popover"
                        placement="top-start"
                        title
                        width="200"
                        trigger="click"
                      >
                        <span class="fz-12">{{ `${$t('openRegister')}` }}</span>
                        <br />
                        <br />
                        <span class="fz-12">{{ `${$t('closeRegister')}` }}</span>
                        <i
                          slot="reference"
                          class="iconfont icon-question fz-14 cur_pointer text-color-blue"
                        ></i>
                      </el-popover>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <el-row type="flex" align="middle">
                <selectStandardId @updateStandardId="updateStandardId" />
                <el-input
                  v-model.trim="searchEncodeRuleKey"
                  :placeholder="`${$t('searchForEncodingRuleNames')}`"
                  clearable
                  size="small"
                  class="mr-10px w-200px ml-10px"
                ></el-input>
                <el-button type="primary" @click="initEncodeRuleList">{{ $t('search') }}</el-button>
                <el-button
                  :disabled="!$hasAccess('create')"
                  type="primary"
                  @click="openEncodeRuleEditDialog(null)"
                  >{{ $t('new') }}</el-button
                >
                <el-button
                  :disabled="!$hasAccess('delete')"
                  type="danger"
                  @click="deleteEncodeRule(encodeRuleSelectionIds)"
                  >{{ $t('delete') }}</el-button
                >
                <el-button :disabled="!$hasAccess('export')" @click="exportEncodeRule">{{
                  $t('export')
                }}</el-button>
                <el-button :disabled="!$hasAccess('import')" @click="importCodeFile">{{
                  $t('import')
                }}</el-button>
              </el-row>
              <div class="mt-20px table-content">
                <el-table
                  :data="encodeRuleList"
                  v-loading="encodeRuleListLoading"
                  height="100%"
                  border
                  stripe
                  ref="encodeRuleTable"
                  row-key="id"
                  @selection-change="selectionEncodeRule"
                  @row-click="getEncodeRuleDetail"
                  highlight-current-row
                >
                  <el-table-column
                    :reserve-selection="true"
                    type="selection"
                    width="40px"
                  ></el-table-column>
                  <el-table-column
                    prop="seqNo"
                    :label="`${$t('serialNumber')}`"
                    width="75px"
                  ></el-table-column>
                  <el-table-column
                    prop="name"
                    :label="`${$t('theEncodingName')}`"
                  ></el-table-column>
                  <el-table-column
                    prop="baseRuleDatas"
                    :label="`${$t('encodingRules')}`"
                    :formatter="setBaseRules"
                  ></el-table-column>
                  <el-table-column
                    prop="ruleScope"
                    :formatter="setRuleScope"
                    align="center"
                    :label="`${$t('ruleScope')}`"
                  ></el-table-column>

                  <el-table-column :label="`${$t('switch')}`" align="center" width="100px">
                    <template #default="{ row }">
                      <el-switch
                        v-model="row.isOpen"
                        active-color="#13ce66"
                        inactive-color="#e7e9ee"
                        :active-value="1"
                        :inactive-value="0"
                        @change="changeOpenStauts(row)"
                      ></el-switch>
                    </template>
                  </el-table-column>
                  <el-table-column :label="`${$t('operate')}`" align="center" width="180px">
                    <template #default="{ row }">
                      <el-button
                        :disabled="!$hasAccess('update')"
                        size="mini"
                        @click="openEncodeRuleEditDialog(row)"
                        >{{ $t('edit') }}</el-button
                      >
                      <el-button
                        :disabled="!$hasAccess('delete')"
                        size="mini"
                        @click="deleteEncodeRule([row.id])"
                        >{{ $t('delete') }}</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  background
                  @size-change="changeEncodeRuleSize"
                  @current-change="changeEncodeRulePage"
                  :current-page.sync="encodeRulePagination.pageNo"
                  :page-size.sync="encodeRulePagination.pageSize"
                  :page-sizes="$pageSizeAll"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="encodeRulePagination.totalCount"
                  class="mt-20px float-right"
                ></el-pagination>
              </div>
            </el-card>
          </el-col>
          <el-col class="h-full" :span="10">
            <el-card
              class="h-full w-full"
              :body-style="{ height: 'calc(100% - 44px)', padding: '0 10px 10px 10px' }"
            >
              <div slot="header">
                <el-row :gutter="10" class="fz-16" type="flex" align="middle">
                  <el-col :span="24">
                    <span>{{ `${$t('ruleBreakdown')}` }}</span>
                  </el-col>
                </el-row>
              </div>
              <el-tabs class="detail-tabs h-full" v-model="ruleDetailActiveName">
                <el-tab-pane class="h-full" :label="`${$t('codeRules')}`" name="encodeRuleDetail">
                  <div class="h-full">
                    <el-table :data="baseRuleDetailList" height="100%" border stripe>
                      <el-table-column
                        prop="seqNo"
                        :label="`${$t('serialNumber')}`"
                        width="75px"
                      ></el-table-column>
                      <el-table-column
                        prop="name"
                        :label="`${$t('referenceTheUnderlyingRule')}`"
                      ></el-table-column>
                      <el-table-column
                        prop="significantDigits"
                        :label="`${$t('numberOfDigits')}`"
                      ></el-table-column>
                      <el-table-column :label="`${$t('operate')}`" align="center" width="180px">
                        <template #default="{ row }">
                          <el-button
                            :disabled="!$hasAccess('delete')"
                            size="mini"
                            @click="encodeRuleClick(row)"
                            >{{ $t('delete') }}</el-button
                          >
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </el-tab-pane>
                <el-tab-pane
                  class="h-full"
                  :label="`${$t('associateAttributeRules')}`"
                  name="attributeRuleRelationDetail"
                >
                  <div class="h-full">
                    <el-table :data="attrRuleDetailList" height="100%" border stripe>
                      <el-table-column
                        :label="`${$t('serialNumber')}`"
                        type="index"
                        width="75px"
                      ></el-table-column>
                      <el-table-column
                        prop="typeString"
                        :label="`${$t('propertyName')}`"
                        width="100px"
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column prop="codeStartIndex" :label="`${$t('customRules')}`">
                        <template #default="{ row }"
                          >第{{ row.codeStartIndex }}-{{ row.codeEndIndex }}位编码</template
                        >
                      </el-table-column>
                      <el-table-column
                        prop="defaultCode"
                        :label="`${$t('theDefaultSetting')}`"
                      ></el-table-column>
                      <el-table-column :label="`${$t('operate')}`" align="center" width="80px">
                        <template>
                          <el-button
                            :disabled="!$hasAccess('update')"
                            size="mini"
                            @click="openEncodeRuleEditDialog(currentEncodeRuleRow, 'attributeRule')"
                            >{{ $t('edit') }}</el-button
                          >
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </el-card>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
    <!-- 基础规则编辑框 -->
    <el-dialog
      :title="baseRuleId ? `${$t('editTheUnderlyingRule')}` : `${$t('addedBasicRules')}`"
      :visible.sync="baseRuleDialogVisible"
      class="mini-dialog"
      :close-on-click-modal="false"
      :before-close="closeBaseRuleDialog"
      v-dialogDrag
    >
      <div>
        <el-form
          ref="baseRuleForm"
          :model="baseRuleForm"
          label-width="150px"
          :rules="baseRuleFormRules"
          size="small"
        >
          <el-form-item :label="`${$t('serialNumber')}`" prop="seqNo">
            <el-input v-model.number="baseRuleForm.seqNo"></el-input>
          </el-form-item>
          <el-form-item :label="`${$t('ruleName')}`" prop="name">
            <el-input v-model="baseRuleForm.name" clearable></el-input>
          </el-form-item>
          <el-form-item :label="`${$t('ruleDefinitions')}`" prop="definition">
            <el-input
              v-model.trim="baseRuleForm.definition"
              clearable
              :placeholder="`${$t('pleaseFillInTheRegularExpression')}`"
            ></el-input>
          </el-form-item>
          <el-form-item :label="`${$t('numberOfDigits')}`">
            <el-input v-model.number="baseRuleForm.significantDigits" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="closeBaseRuleDialog" :loading="baseRuleAddLoading">{{
          `${$t('Cancel')}`
        }}</el-button>
        <el-button type="primary" :loading="baseRuleAddLoading" @click="submitBaseRule">{{
          `${$t('Sure')}`
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 编码规则编辑框 -->
    <el-dialog
      :title="encodeRuleId ? `${$t('editTheEncodingRules')}` : `${$t('addedEncodingRules')}`"
      :visible.sync="encodeRuleDialogVisible"
      class="small-dialog"
      :close-on-click-modal="false"
      :before-close="closeEncodeRuleDialog"
      v-dialogDrag
    >
      <el-tabs v-model="encodeRuleEditActiveName">
        <el-tab-pane :label="`${$t('encodingRules')}`" name="encodeRule">
          <div>
            <el-form
              ref="encodeRuleForm"
              :model="encodeRuleForm"
              label-width="150px"
              :rules="encodeRuleFormRules"
              size="small"
            >
              <el-form-item :label="`${$t('serialNumber')}`" prop="seqNo">
                <el-input v-model.number="encodeRuleForm.seqNo"></el-input>
              </el-form-item>
              <el-form-item :label="`${$t('theEncodingName')}`" prop="name">
                <el-input v-model="encodeRuleForm.name" clearable></el-input>
              </el-form-item>
              <el-form-item :label="`${$t('encodingRules')}`" prop="baseRuleIds">
                <el-select
                  v-model="encodeRuleForm.baseRuleIds"
                  :placeholder="`${$t('pleaseSelect')}`"
                  clearable
                  class="w-full"
                  filterable
                  multiple
                  collapse-tags
                >
                  <el-option
                    v-for="item in baseRuleAllList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="`${$t('ruleScope')}`" prop="ruleScope">
                <el-select
                  v-model="encodeRuleForm.ruleScope"
                  :placeholder="`${$t('pleaseSelect')}`"
                  clearable
                  class="w-full"
                  filterable
                >
                  <el-option
                    v-for="item in encodeRuleScopeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="`${$t('associateAttributeRules')}`" name="attributeRule">
          <div class="w-full">
            <el-table :data="attributeRuleRelationList" class="w-full" border stripe>
              <el-table-column
                prop="name"
                :label="`${$t('propertyName')}`"
                width="80px"
              ></el-table-column>
              <el-table-column prop="attributeRule" :label="`${$t('attributeEncodingRules')}`">
                <template #default="{ row }">
                  <div class="attributeRule">
                    <span>{{ `${$t('customRules')}` }}:</span>
                    <p class="is-inline ml-10px attributeRule_mini">
                      取当前编码中第
                      <el-input
                        v-model="encodeRuleForm.propertyDatas[row.index].codeStartIndex"
                        class="is-inline mr-5px"
                        placeholder
                        size="mini"
                      ></el-input
                      >码至第
                      <el-input
                        v-model="encodeRuleForm.propertyDatas[row.index].codeEndIndex"
                        class="is-inline mr-5px"
                        placeholder
                        size="mini"
                      ></el-input>
                      码为{{ row.name }}属性
                    </p>
                  </div>
                  <div class="attributeRule">
                    <span>{{ `${$t('theDefaultSetting')}` }}:</span>
                    <p class="is-inline ml-10px" v-if="row.name === '类别'">
                      <el-cascader
                        v-model="encodeRuleForm.propertyDatas[row.index].defaultCodeId"
                        size="small"
                        filterable
                        clearable
                        :show-all-levels="false"
                        :options="row.option"
                        :props="{ checkStrictly: true, value: 'id', label: 'name' }"
                        class="w-full"
                      ></el-cascader>
                    </p>
                    <p class="is-inline ml-10px" v-else>
                      <el-select
                        v-model="encodeRuleForm.propertyDatas[row.index].defaultCodeId"
                        value-key
                        :placeholder="row.placeholder"
                        :remote-method="debounce(getTagClassList, 1000)"
                        clearable
                        filterable
                        remote
                        size="small"
                        :loading="tagClassLoading"
                        class="w-full"
                      >
                        <el-option
                          v-for="item in row.option"
                          :key="item.id"
                          :label="`${item.code}[${item.name}]`"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </p>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer">
        <el-button @click="closeEncodeRuleDialog" :loading="baseRuleAddLoading">{{
          `${$t('Cancel')}`
        }}</el-button>
        <el-button type="primary" :loading="encodeRuleAddLoading" @click="submitEncodeRule">{{
          `${$t('Sure')}`
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 基础规则上传 -->
    <wiz-upload-file
      v-dialogDrag
      @refreshList="initBaseRuleList"
      :uploadFileProps="baseUploadFileProps"
      @exportTemplate="exportBaseTemplate"
      @importTemplate="importBaseTemplate"
    ></wiz-upload-file>
    <!-- 编码规则上传 -->
    <wiz-upload-file
      v-dialogDrag
      @refreshList="initEncodeRuleList"
      :uploadFileProps="codeUploadFileProps"
      @exportTemplate="exportCodeTemplate"
      @importTemplate="importCodeTemplate"
    ></wiz-upload-file>
  </el-card>
</template>

<script>
import EncodeRuleManage from '@/services/encodeRule'
// import TagService from '@/services/tags'
import ApiMixinTags from '@/assets/js/api/tags'
import ApiMixinSystem from '@/assets/js/api/systemParams'
// import { access } from 'fs'
import fnMixin from '@/assets/js/fnMixins'
import selectStandardId from '../../components/selectStandardId'

export default {
  name: 'BaseRuleManage',
  mixins: [ApiMixinTags, ApiMixinSystem, fnMixin],
  components: { selectStandardId },
  data() {
    const checkSeqNo = (rule, value, callback) => {
      if (!value && value !== 0) {
        callback(new Error(`${this.$t('SerialNumberCannotBeEmpty')}`))
      } else if (value.length > 10) {
        callback(new Error(`${this.$t('LengthCannotExceedTenCharacters')}`))
      } else if (!_.isInteger(value) || value < 1) {
        callback(new Error(`${this.$t('sequenceNumberMustThanZero')}`))
      } else {
        callback()
      }
    }
    const checkRegExp = (rule, value, callback) => {
      let isRegExp = true
      try {
        new RegExp(value)
      } catch (e) {
        isRegExp = false
      }
      if (value && isRegExp) {
        callback()
      } else {
        callback(new Error(`${this.$t('reg')}`))
      }
    }
    return {
      baseUploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 1, // 目前状态页面1为下载模板 2为上传模板 3为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      codeUploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 1, // 目前状态页面1为下载模板 2为上传模板 3为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      tabActive: 'base',
      searchBaseRuleKey: '', // 搜索基础规则名称
      baseRuleList: [], // 基础规则列表
      baseRuleAllList: [], // 所有的基础规则
      baseRuleListLoading: false, // 基础规则列表加载
      // 基础规则列表分页
      baseRulePagination: {
        pageNo: 1,
        pageSize: 15,
        totalCount: 0,
      },
      baseRuleDialogVisible: false, // 基础规则编辑框可见
      baseRuleId: null, // 基础规则id
      baseRuleFormRules: {
        seqNo: [{ required: true, validator: checkSeqNo, trigger: 'blur' }],
        name: [{ required: true, message: '请填写规则名称', trigger: 'blur' }],
        definition: [{ required: true, validator: checkRegExp, trigger: 'blur' }],
      }, // 基础规则表单校验
      // 基础规则表单数据
      baseRuleForm: {
        seqNo: 0,
        name: '',
        definition: '',
        significantDigits: '',
      },
      baseRuleAddLoading: false, // 基础规则数据保存按钮loading
      baseRuleSelectionIds: [], // 选中列表id集合

      isAllRegister: false, // 编码规则管理，是否全部注册
      isAllRegisterParams: [],
      searchEncodeRuleKey: '', // 关键字搜索编码规则
      encodeRuleList: [], // 编码规则列表
      encodeRuleListLoading: false, // 编码规则列表加载loading
      // 编码规则列表分页
      encodeRulePagination: {
        pageNo: 1,
        pageSize: 15,
        totalCount: 0,
      },
      currentEncodeRuleRow: null,
      encodeRuleDialogVisible: false, // 编码规则编辑框可见
      encodeRuleId: null, // 编码规则id
      encodeRuleFormRules: {
        seqNo: [{ required: true, validator: checkSeqNo, trigger: 'blur' }],
        name: [{ required: true, message: '请填写编码名称', trigger: 'blur' }],
        baseRuleIds: [{ required: true, message: '请选择编码规则', trigger: 'change' }],
        ruleScope: [{ required: true, message: '请选择规则范围', trigger: 'change' }],
      }, // 编码规则表单校验
      // 编码规则表单数据
      encodeRuleForm: {
        seqNo: 1,
        name: '',
        baseRuleIds: [],
        ruleScope: '',
        isOpen: 0,
        propertyDatas: [
          {
            type: 0,
            codeStartIndex: 0,
            codeEndIndex: 0,
            defaultCodeId: '',
          },
          {
            type: 1,
            codeStartIndex: 0,
            codeEndIndex: 0,
            defaultCodeId: '',
          },
        ],
      },
      encodeRuleAddLoading: false, // 编码规则数据保存按钮loading
      encodeRuleScopeList: [
        { value: 0, label: '全部' },
        { value: 1, label: '图档' },
        { value: 2, label: '模型' },
      ], // 编码规则范围
      encodeRuleSelectionIds: [], // 选中列表id集合
      encodeRuleEditActiveName: 'encodeRule',
      classOptionsProps: { value: 'id', label: 'lable' },
      attributeRuleRelationList: [
        {
          index: 0,
          name: '类别',
          placeholder: '请填写类别编码作为默认类别设置',
          option: [],
          attributeRule: {
            type: 0,
            codeStartIndex: '',
            codeEndIndex: '',
            defaultCodeId: '',
          },
        },
        {
          index: 1,
          name: '上级',
          placeholder: '请填写位号编码作为默认上级设置',
          option: [],
          attributeRule: {
            type: 1,
            codeStartIndex: '',
            codeEndIndex: '',
            defaultCodeId: '',
          },
        },
      ], // 关联属性规则列表

      ruleDetailActiveName: 'encodeRuleDetail', // 规则明细
      baseRuleDetailList: [], // 基础规则明细列表
      attrRuleDetailList: [], // 属性规则明细
      uploadVisible: false, // 导出弹框可见
      uploadExcelType: 'baseRule', // 导入文件类型
      tagClassLoading: false,
      //  标准部分
      standardId: localStorage.getItem('standardId'),
      classTypeList: [], // 类别列表
      systemParams: localStorage.getItem('systemParams')
        ? JSON.parse(localStorage.getItem('systemParams'))
        : [],
    }
  },
  computed: {
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
    // 位号默认分类
    tagDefaultClassify() {
      const classify = _.find(this.systemParams, { parameterCode: 'tagDefaultClassify' }) || {}
      return classify.parameterValue || ''
    },
  },
  watch: {
    standardId(newVal) {
      if (newVal) {
        this.initBaseRuleList() // 分页获取基础规则
        this.initEncodeRuleList() // 分页获取编码规则
        this.getTagClassTag() // 获取类别选项
        this.getTagClassList() // 获取部分上级位号
        this.getAllBaseRuleList() // 获取编码规则下拉列表
      }
    },
  },
  async created() {
    if (this.standardId) {
      this.initBaseRuleList() // 分页获取基础规则
      this.initEncodeRuleList() // 分页获取编码规则
      this.getTagClassTag() // 获取类别选项
      this.getTagClassList() // 获取部分上级位号
    }
    // 获取是否全局注册
    this.isAllRegisterParams =
      _.find(this.systemParams, { parameterCode: 'codeRuleGlobalRegister' }) || ''
    if (this.isAllRegisterParams && this.isAllRegisterParams.parameterValue) {
      this.isAllRegister = this.isAllRegisterParams.parameterValue === 'true'
    } else {
      this.isAllRegister = false
    }
  },
  activated() {
    this.standardId = localStorage.getItem('standardId')
  },
  methods: {
    // 导入基础规则
    importBaseFile() {
      this.baseUploadFileProps.visible = true
      this.baseUploadFileProps.active = 0
    },
    // 下载基础规则导入模板
    async exportBaseTemplate() {
      const res = await EncodeRuleManage.getBaseRuleTemplate()
      // 返回的是文件流
      if (res) {
        this.downLoadBlob({
          name: '基础规则导入模板.xlsx',
          data: res,
        })
      }
    },
    // 上传基础规则已填写的模板
    async importBaseTemplate(file) {
      this.baseUploadFileProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append(key, value)
      })
      formData.append('standardId', this.standardId)
      const res = await EncodeRuleManage.uploadBaseRule(formData)
      if (res) {
        this.baseUploadFileProps.active = 2
        this.downLoadBlob({
          name: '基础规则导入明细.xlsx',
          data: res,
        })
        this.initBaseRuleList()
      }
      this.baseUploadFileProps.btnLoading = false
    },
    // 导入编码规则
    importCodeFile() {
      this.codeUploadFileProps.visible = true
      this.codeUploadFileProps.active = 0
    },
    // 下载编码规则导入模板
    async exportCodeTemplate() {
      const res = await EncodeRuleManage.getEncodeRuleTemplate()
      // 返回的是文件流
      if (res) {
        this.downLoadBlob({
          name: '编码规则导入模板.xlsx',
          data: res,
        })
      }
    },
    // 上传编码规则已填写的模板
    async importCodeTemplate(file) {
      this.codeUploadFileProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append(key, value)
      })
      formData.append('standardId', this.standardId)
      const res = await EncodeRuleManage.uploadEncodeRule(formData)
      if (res) {
        this.codeUploadFileProps.active = 2
        this.downLoadBlob({
          name: '编码规则导入明细.xlsx',
          data: res,
        })
        this.initEncodeRuleList()
      }
      this.codeUploadFileProps.btnLoading = false
    },
    updateStandardId(val) {
      this.standardId = val
    },
    // 基础规则————初始化列表
    async initBaseRuleList() {
      this.baseRuleListLoading = true
      const res = await EncodeRuleManage.getBaseRuleList({
        Name: this.searchBaseRuleKey,
        SkipCount: this.baseRulePagination.pageNo,
        MaxResultCount: this.baseRulePagination.pageSize,
        StandardId: this.standardId,
        Sorting: 'seq_no asc',
      })
      this.baseRuleListLoading = false
      if (res && res.code === 0 && res.data) {
        this.baseRuleList = res.data
        this.$nextTick(() => {
          this.$refs.baseRuleTable.doLayout()
        })
        this.baseRulePagination.totalCount = res.totalCount
      }
    },
    // 编码规则 --- 获取所有的基础规则
    async getAllBaseRuleList() {
      const res = await EncodeRuleManage.getBaseRuleList({
        Name: '',
        SkipCount: 1,
        MaxResultCount: 999,
        StandardId: this.standardId,
        Sorting: 'seq_no asc',
      })
      if (res && res.code === 0 && res.data) {
        this.baseRuleAllList = res.data
      }
    },

    // 基础规则————保存
    submitBaseRule() {
      this.$refs.baseRuleForm.validate(async (valid) => {
        if (valid) {
          const params = this.baseRuleForm
          params.significantDigits = _.isNaN(parseInt(this.baseRuleForm.significantDigits, 10))
            ? 0
            : this.baseRuleForm.significantDigits
          params.standardId = this.standardId
          let res = null
          this.baseRuleAddLoading = true
          if (this.baseRuleId) {
            params.id = this.baseRuleId
            res = await EncodeRuleManage.editBaseRule(params)
          } else {
            res = await EncodeRuleManage.addBaseRule(params)
          }
          this.baseRuleAddLoading = false
          if (res && res.code === 0) {
            this.closeBaseRuleDialog()
            this.initBaseRuleList()
            this.$message.success('保存成功')
          } else {
            this.$message.warning(res.msg)
          }
          return true
        }
        return false
      })
    },
    // 基础规则————删除规则
    deleteBaseRule(ids) {
      if (_.isEmpty(ids)) {
        this.$message.warning(`${this.$t('pleaseSelectTheDataYouWantToDelete')}`)
        return
      }
      this.$confirm(`${this.$t('whetherToDeleteTheUnderlyingRule')}`, this.$t('hint'), {
        confirmButtonText: this.$t('Sure'),
        cancelButtonText: this.$t('Cancel'),
        type: 'warning',
      })
        .then(async () => {
          const res = await EncodeRuleManage.deleteBaseRule(ids)
          if (res && res.code === 0) {
            this.$message.success(`${this.$t('deletionSuccessful')}`)
            if (this.baseRuleList.length === 1 && this.baseRulePagination.pageNo > 1) {
              this.baseRulePagination.pageNo -= 1
            }
            if (ids.length > 1) {
              this.baseRulePagination.pageNo = 1
            }
            this.initBaseRuleList()
            this.$refs.baseRuleTable.clearSelection()
          } else {
            this.$message.warning(res.message)
          }
        })
        .catch(() => {})
    },
    // 基础规则————导出excel
    exportBaseRule() {
      if (_.isEmpty(this.baseRuleSelectionIds)) {
        this.$confirm(this.$t('ContinueExportingAllData'), this.$t('hint'), {
          confirmButtonText: this.$t('Sure'),
          cancelButtonText: this.$t('Cancel'),
          type: 'warning',
        })
          .then(async () => {
            this.exportBaseRuleByKeyword()
          })
          .catch(() => {})
      } else {
        this.exportBaseRuleById()
      }
    },
    // 基础规则————按关键字导出
    async exportBaseRuleByKeyword() {
      const res = await EncodeRuleManage.exportBaseRule({
        name: this.searchBaseRuleKey,
        standardId: this.standardId,
      })
      if (res) {
        this.downLoadExcel('基础规则导出结果.xlsx', res)
      }
    },
    // 基础规则————按id导出
    async exportBaseRuleById() {
      const res = await EncodeRuleManage.exportBaseRule({
        baseRuleIds: this.baseRuleSelectionIds,
        standardId: this.standardId,
      })
      if (res) {
        this.downLoadExcel('基础规则导出结果.xlsx', res)
      }
    },
    // 基础规则————打开编辑框
    openBaseRuleEditDialog(row) {
      if (row) {
        this.baseRuleId = row.id
        this.baseRuleForm = _.pick(row, ['seqNo', 'name', 'definition', 'significantDigits'])
      }
      this.baseRuleDialogVisible = true
    },
    // 基础规则————选择列表项
    selectionBaseRule(rows) {
      this.baseRuleSelectionIds = _.map(rows, 'id')
    },
    // 基础规则————关闭编辑框
    closeBaseRuleDialog() {
      this.$refs.baseRuleForm.resetFields()
      this.baseRuleForm = this.$options.data().baseRuleForm
      this.baseRuleDialogVisible = false
      this.baseRuleId = null
    },
    // 基础规则————切换pageSize
    changeBaseRuleSize() {
      this.baseRulePagination.pageNo = 1
      this.initBaseRuleList()
    },
    // 基础规则————换页
    changeBaseRulePage() {
      this.initBaseRuleList()
    },
    // 导入功能
    changeUploadDialog(data) {
      this.uploadVisible = data
    },
    // 编码规则————初始化列表
    async initEncodeRuleList() {
      this.encodeRuleListLoading = true
      const res = await EncodeRuleManage.getEncodeRuleList({
        Name: this.searchEncodeRuleKey,
        SkipCount: this.encodeRulePagination.pageNo,
        MaxResultCount: this.encodeRulePagination.pageSize,
        StandardId: this.standardId,
        Sorting: 'seq_no asc',
      })
      this.encodeRuleListLoading = false
      if (res && res.code === 0 && res.data) {
        this.encodeRuleList = res.data
        this.encodeRulePagination.totalCount = res.totalCount
        this.$nextTick(() => {
          this.$refs.encodeRuleTable.doLayout()
        })
      }
    },
    // 编码规则 ---formatter 规则范围
    setRuleScope(row) {
      const encodeRuleScope = _.find(this.encodeRuleScopeList, ['value', row.ruleScope])
      if (encodeRuleScope) {
        return encodeRuleScope.label
      }
      return false
    },
    // 编码规则 ---formatter 编码规则
    setBaseRules(row) {
      return _.map(row.baseRuleDatas, (res) => {
        return res.name
      }).join('+')
    },
    // 编码规则————打开编辑框
    openEncodeRuleEditDialog(row, activeTab) {
      this.encodeRuleEditActiveName = activeTab || 'encodeRule'
      if (row) {
        this.encodeRuleId = row.id
        _.assign(this.encodeRuleForm, row)
        this.encodeRuleForm.baseRuleIds = _.map(this.encodeRuleForm.baseRuleDatas, (data) => {
          return data.id
        })
        this.getTagClassList(row.propertyDatas[1].defaultCode)
      }
      this.encodeRuleDialogVisible = true
    },
    // 编码规则————保存
    submitEncodeRule() {
      this.$refs.encodeRuleForm.validate(async (valid) => {
        if (valid) {
          // 判断起始位置和终点位置是否合法
          let flag = true
          _.forEach(this.encodeRuleForm.propertyDatas, (propertyData) => {
            if (Number(propertyData.codeEndIndex) < Number(propertyData.codeStartIndex)) {
              this.$message.warning(`${this.$t('theStartIndexCannotBeGreaterThanTheEndIndex')}`)
              flag = false
            }
          })
          if (!flag) {
            return
          }
          this.encodeRuleAddLoading = true
          this.encodeRuleForm.propertyDatas[0].defaultCodeId = Array.isArray(
            this.encodeRuleForm.propertyDatas[0].defaultCodeId
          )
            ? _.last(this.encodeRuleForm.propertyDatas[0].defaultCodeId)
            : this.encodeRuleForm.propertyDatas[0].defaultCodeId
          _.map(this.classTypeList, (item) => {
            if (item.id === this.encodeRuleForm.propertyDatas[0].defaultCodeId) {
              this.encodeRuleForm.propertyDatas[0].defaultCode = item.name
            } else {
              _.map(item.children, (cItem) => {
                if (cItem.id === this.encodeRuleForm.propertyDatas[0].defaultCodeId) {
                  this.encodeRuleForm.propertyDatas[0].defaultCode = cItem.name
                }
              })
            }
          })
          const params = this.encodeRuleForm
          params.standardId = this.standardId
          let res = null
          if (this.encodeRuleId) {
            params.id = this.encodeRuleId
            res = await EncodeRuleManage.editEncodeRule(params)
          } else {
            res = await EncodeRuleManage.addEncodeRule(params)
          }
          this.encodeRuleAddLoading = false
          if (res && res.code === 0) {
            this.closeEncodeRuleDialog()
            this.$message.success('新增成功')
            this.initEncodeRuleList()
            if (this.currentEncodeRuleRow) {
              const currentRow = _.find(this.encodeRuleList, ['id', this.currentEncodeRuleRow.id])
              this.baseRuleDetailList = currentRow.baseRuleDatas || []
              this.attrRuleDetailList = currentRow.propertyDatas || []
            } else {
              this.baseRuleDetailList = []
              this.attrRuleDetailList = []
            }
          } else {
            this.$message.warning(res.msg)
          }
          // return true
        }
        // return false
      })
    },
    // 编码规则 ---- 获取类别选项
    async getTagClassTag() {
      const res = await EncodeRuleManage.getClassAndAttribute({
        standardId: this.standardId,
        data_type: 1,
      })
      if (res && res.code === 0 && !_.isEmpty(res.data)) {
        this.classTypeList = res.data
        this.attributeRuleRelationList[0].option = res.data
        // 默认选中，系统参数中可配置
        this.encodeRuleForm.propertyDatas[0].defaultCodeId = [this.tagDefaultClassify]
      }
    },
    // 编码规则---处理类别树
    disposeTreeData(treeData, key, id) {
      const filterList = []
      let newData = _.map(treeData, (item) => {
        if (item.id === id) {
          filterList.push(item)
        } else if (item[key] && item[key].length) {
          item[key] = this.disposeTreeData(item.nodes, key, id)
        }
        return item
      })
      newData = _.differenceWith(newData, filterList, _.isEqual)
      return newData
    },
    // 编码规则---获取上级位号防抖
    debounce(fn, delay) {
      let timeout = null
      // eslint-disable-next-line func-names
      return function() {
        clearTimeout(timeout)
        timeout = setTimeout(() => {
          // eslint-disable-next-line prefer-rest-params
          fn.apply(this, arguments)
        }, delay)
      }
    },
    // 删除编码规则和基础规则关联关系
    encodeRuleClick(row) {
      this.$confirm(`${this.$t('whetheToDeleteTheEncodingRule')}`, this.$t('hint'), {
        confirmButtonText: this.$t('Sure'),
        cancelButtonText: this.$t('Cancel'),
        type: 'warning',
      })
        .then(async () => {
          const res = await EncodeRuleManage.delEncodeRule([row.codeRuleAndBaseRuleAssociationId])
          if (res && res.code === 0) {
            this.$message.success('删除成功')
            await this.initEncodeRuleList()
            const currentRow = _.find(this.encodeRuleList, ['id', this.currentEncodeRuleRow.id])
            this.$nextTick(() => {
              this.$refs.encodeRuleTable.setCurrentRow(currentRow)
            })
            this.baseRuleDetailList = currentRow.baseRuleDatas || []
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(() => {})
    },
    // 编码规则 --- 获取上级位号
    async getTagClassList(keyWord = '') {
      this.tagClassLoading = true
      const res = await this.apiTags({
        method: 'parentTagsByNameOrCode',
        params: {
          standardId: this.standardId,
          keyword: encodeURIComponent(keyWord),
        },
      })
      this.tagClassLoading = false
      if (res && !_.isEmpty(res.data) && res.code === 0) {
        this.attributeRuleRelationList[1].option = res.data
      } else {
        this.attributeRuleRelationList[1].option = []
      }
    },
    // 编码规则————选择列表项
    selectionEncodeRule(rows) {
      this.encodeRuleSelectionIds = _.map(rows, 'id')
    },
    // 编码规则————删除编码规则
    async deleteEncodeRule(ids) {
      if (_.isEmpty(ids)) {
        this.$message.warning(`${this.$t('pleaseSelectTheDataYouWantToDelete')}`)
        return
      }
      this.$confirm(`${this.$t('whetheToDeleteTheEncodingRule')}`, this.$t('hint'), {
        confirmButtonText: this.$t('Sure'),
        cancelButtonText: this.$t('Cancel'),
        type: 'warning',
      })
        .then(async () => {
          const res = await EncodeRuleManage.deleteEncodeRule(ids)
          if (res && res.code === 0) {
            this.$message.success(`${this.$t('deletionSuccessful')}`)
            if (this.encodeRuleList.length === 1 && this.encodeRulePagination.pageNo > 1) {
              this.encodeRulePagination.pageNo -= 1
            }
            if (ids.length > 1) {
              this.encodeRulePagination.pageNo = 1
            }
            this.initEncodeRuleList()
            this.baseRuleDetailList = []
            this.attrRuleDetailList = []
            this.$refs.encodeRuleTable.clearSelection()
          } else {
            this.$message.warning(res.message)
          }
        })
        .catch(() => {})
    },
    // 编码规则————关闭编辑框
    closeEncodeRuleDialog() {
      this.$refs.encodeRuleForm.resetFields()
      this.encodeRuleEditActiveName = this.$options.data().encodeRuleEditActiveName
      this.encodeRuleForm = this.$options.data().encodeRuleForm
      this.encodeRuleDialogVisible = false
      this.encodeRuleAddLoading = false
      this.encodeRuleId = null
    },
    // 编码规则————切换pageSize
    async changeEncodeRuleSize() {
      this.baseRulePagination.pageNo = 1
      await this.initEncodeRuleList()
    },
    // 编码规则————换页
    changeEncodeRulePage() {
      this.initEncodeRuleList()
    },
    // 编码规则 --- 获取规则明细
    getEncodeRuleDetail(row) {
      this.currentEncodeRuleRow = row
      this.baseRuleDetailList = row.baseRuleDatas
      this.attrRuleDetailList = row.propertyDatas
    },
    // 编码规则---开关切换
    async changeOpenStauts(row) {
      // 修改规则状态
      const param = row
      param.siteId = this.currentProject.id
      param.baseRuleIds = _.map(row.baseRuleDatas, (data) => {
        return data.id
      })
      const res = await EncodeRuleManage.editEncodeRule(param)
      if (res && res.code === 0) {
        // console.log('编辑状态----', res.msg)
      } else {
        this.$message.error(res.msg)
      }
    },
    // 编码规则---全局注册
    changeAllRegister(status) {
      // 更新系统参数 vuex
      this.updateSystemParams(status)
    },
    // 编码规则---导出
    exportEncodeRule() {
      if (_.isEmpty(this.encodeRuleSelectionIds)) {
        this.$confirm(`${this.$t('ContinueExportingAllData')}`, this.$t('hint'), {
          confirmButtonText: this.$t('Sure'),
          cancelButtonText: this.$t('Cancel'),
          type: 'warning',
        })
          .then(async () => {
            this.exportEncodeRuleByKeyword()
          })
          .catch(() => {})
      } else {
        this.exportEncodeRuleByKeyword()
      }
    },
    // 编码规则 ————按关键字导出
    async exportEncodeRuleByKeyword() {
      const res = await EncodeRuleManage.exportEncodeRule({
        ids: this.encodeRuleSelectionIds,
        name: this.searchEncodeRuleKey,
        standardId: this.standardId,
      })
      if (res) {
        this.downLoadExcel('编码规则导出结果.xlsx', res)
      }
    },
    handleClick(tab) {
      if (tab.name === 'encode') {
        this.getAllBaseRuleList()
      }
    },
    updateSystemParams(status) {
      const params = [
        {
          id: this.isAllRegisterParams.id || '',
          parameterValue: status,
          remark: this.isAllRegisterParams.remark || null,
          parentId: this.isAllRegisterParams.parentId || null,
          parameterType: this.isAllRegisterParams.parameterType,
          parameterCode: this.isAllRegisterParams.parameterCode || null,
          parameterName: this.isAllRegisterParams.parameterName || null,
          createdUser: this.isAllRegisterParams.createdUser || null,
        },
      ]
      this.apiSystemParams({
        method: 'updateSystemParams',
        params,
      }).then((res) => {
        if (res && res.code === 0) {
          this.$message.success('注册成功')
          this.updateCommonSystemList()
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    async updateCommonSystemList() {
      const res = await this.apiSystemParams({
        method: 'getSystem',
        params: {
          KeyWord: '',
          ParameterType: '',
        },
      })
      if (res && res.code === 0 && res.data) {
        localStorage.setItem('systemParams', JSON.stringify(res.data))
      }
    },
  },
}
</script>

<style lang="scss" scoped>

.is-inline {
  display: inline;
}
/deep/ .el-tabs__content {
  height: calc(100% - 50px);
}
.detail-tabs {
  /deep/ .el-tabs__header {
    margin: 0 0 13px !important;
  }
}
/deep/ .el-tabs__header {
  margin: 0 0 10px !important;
}
/deep/ .el-card__header {
  padding: 10px !important;
}
.table-content {
  height: calc(100% - 107px);
}
.attributeRule {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 10px;
  span {
    width: 80px;
  }
  p {
    width: calc(100% - 80px);
  }
  .attributeRule_mini {
    /deep/.el-input--mini .el-input__inner {
      width: 40px !important;
      padding: 5px !important;
    }
  }
}

</style>
